import React from 'react'

const Card = ({ children, className, handleClick }: { children: React.ReactNode, className?: string, handleClick?: () => void }) => {
    return (
        <div className={`relative rounded-xl border border-border/50 bg-card p-4 sm:p-5 ease-in-out shadow-sm ${className} ${handleClick ? 'cursor-pointer' : ''}`}
            onClick={handleClick}
        >
            {children}
        </div>
    )
}

export default Card